module.exports = __webpack_public_path__ + "files/b1759df1e32c987904b89413f3b659c2.png";